import { render } from "./Cookies_old.vue?vue&type=template&id=3c0f88ee&scoped=true"
import script from "./Cookies_old.vue?vue&type=script&lang=js"
export * from "./Cookies_old.vue?vue&type=script&lang=js"

import "./Cookies_old.vue?vue&type=style&index=0&id=3c0f88ee&scoped=true&lang=scss"

import exportComponent from "/codebuild/output/src3100558267/src/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3c0f88ee"]])

export default __exports__